// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--jlo6v","title":"a10a3f92e9--title--2hnYc","preloader-wrapper":"a10a3f92e9--preloader-wrapper--3k_CE"};